// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".thumbnail-button[data-v-159cd53e]{background:#000;line-height:0;position:relative}.thumbnail-button img[data-v-159cd53e]{max-width:100%}.thumbnail-button .bg-overlay[data-v-159cd53e]{background:linear-gradient(0deg,rgba(0,0,0,.6),transparent 45.93%);height:100%;left:0;position:absolute;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
